import Api from 'api'

const config = {
  baseURL: '/api/app/v1/payment-orders',
}

const api = new Api(config)

api.fetchPaymentOrders = ({ ...rest }) => api.get('', { ...rest })

api.createPaymentOrder = ({ ...rest }) => api.post('', { ...rest })

api.fetchPaymentOrderById = ({ id, ...rest }) => api.get(`/${id}`, { ...rest })

api.fetchPaymentOrderLink = ({ id, ...rest }) =>
  api.post(`/${id}/payment`, { ...rest })

export default api
